import type { CapacityRemovalImpact } from '@/types/vendor';

export function buildRemovalImpactMessage(entries: CapacityRemovalImpact[]): string {
  return entries
    .map((entry) => {
      if (entry.purchaseOrders.length === 0) {
        return `${entry.typeLabel}: this will delete capacity data for ${entry.weekCount} week(s).`;
      }
      const pos = entry.purchaseOrders.map((po) => `${po.poNumber} (${po.quantity})`).join(', ');
      return `${entry.typeLabel}: this will delete capacity data for ${entry.weekCount} week(s), including purchase orders: ${pos}. This cannot be undone.`;
    })
    .join('\n');
}
